// extracted by mini-css-extract-plugin
export default {"message_container":"VerifyEmail_message_container__f6Y3R","button":"VerifyEmail_button__An2vW"};